import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { cx } from '@emotion/css';

import { useStyles } from './appointment-success-step.styles';
import { ReactComponent as LenseImage } from '../../../../../../assets/images/appointment-success.svg';
import { setRegStep } from '../../../../../../graphql';

export const AppointmentSuccessStep = (): JSX.Element => {
  const classes = useStyles();
  const url = 'https://runtime.video.cloud.yandex.net/player/video/vplvqkz2ydgth5dvga4z?autoplay=0&mute=0';

  useEffect((): void => {
    setRegStep(2);
  }, [setRegStep]);

  return (
    <div className={classes.root}>
      <LenseImage className={classes.lensesImage} />
      <h2
        className={cx(classes.title, 'title-bold')}
        data-testid="appointment-success-step-title"
      >
        <FormattedMessage
          id="appointmentRegistration.appointmentSuccessStep.title"
          values={{ noBreak: <>&nbsp;</> }}
        />
      </h2>
      <p className={classes.description}>
        <FormattedMessage
          id="appointmentRegistration.appointmentSuccessStep.description"
        />
      </p>
      <p className={classes.videoTitle}>
        <FormattedMessage id="appointmentRegistration.appointmentSuccessStep.howToFitLink.text" />
      </p>
      <div className={classes.video} data-testid="success-step-video">
        <iframe
          src={url}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          frameBorder="0"
          height="300"
        />
      </div>
    </div>
  );
};
